module.exports = __webpack_public_path__ + "img/empty_activity.438b1795.svg";